import { type Tab } from 'rc-tabs/lib/interface';
import { ComplianceAssessmentGenerateForm } from './compliance-assessment-generate-form';
import { ComplianceAssessmentHistory } from './compliance-assessment-history';
import { ComplianceAssessmentGuide } from './compliance-assessment-guide';
import { AssessmentTabs } from './constants';

export const ComplianceAssessmentTabs = ({
  activeTabKey,
  setActiveTabKey,
}): Tab[] => {
  return [
    {
      label: AssessmentTabs.Generate,
      children: <ComplianceAssessmentGenerateForm />,
      key: AssessmentTabs.Generate,
    },
    {
      label: AssessmentTabs.History,
      children: (
        <ComplianceAssessmentHistory
          activeTabKey={activeTabKey}
          setActiveTabKey={setActiveTabKey}
        />
      ),
      key: AssessmentTabs.History,
    },
    {
      label: AssessmentTabs.Guide,

      children: <ComplianceAssessmentGuide />,
      key: AssessmentTabs.Guide,
    },
  ];
};
